export const PopularCasinoGamesData = [
    {
        id: 'popular_games_1',
        image: "https://luckmedia.link/aes_baccarat_classic/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'BACCARAT Classic',
        gameId: "SAG-baccaratc01",
        tableId: "SAG"
    },
    {
        id: 'popular_games_2',
        image: "https://luckmedia.link/aes_dragontiger/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Dragon Tiger',
        gameId: "EVO-rngdragontiger0",
        tableId: "EVO"
    },
    {
        id: 'popular_games_3',
        image: "https://luckmedia.link/aes_thai_hi_lo/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Thai Hi Lo',
        gameId: "TRB-hilo",
        tableId: "TRB"
    },
    {
        id: 'popular_games_4',
        image: "https://luckmedia.link/spb_aviator/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Aviator',
        gameId: "SPB-aviator",
        tableId: "SPB"
    },
    {
        id: 'popular_games_5',
        image: "https://luckmedia.link/jil_royal_fishing/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Royal Fishing',
        gameId: "DS-bingofishing",
        tableId: "DS"
    },
    {
        id: 'popular_games_6',
        image: "https://luckmedia.link/dwg_baccarat_evolution_pairs/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Baccarat Evolution Pairs',
        gameId: "EVO-rngbaccarat00000",
        tableId: "EVO"
    },
    {
        id: 'popular_games_7',
        image: "https://luckmedia.link/evo_speed_baccarat_n/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Speed Baccarat N',
        gameId: "EVO-speedbaccarat",
        tableId: "EVO"
    },
    {
        id: 'popular_games_8',
        image: "https://luckmedia.link/evo_deal_or_no_deal/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Deal Or No Deal',
        gameId: "EVO-firstpersondealornodeal",
        tableId: "EVO"
    },
    {
        id: 'popular_games_11',
        image: "https://luckmedia.link/rtg_aztec_spins/thumb_3_4_custom.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        name: 'Azrec Spins',
        gameId: "DS-aztectreasure",
        tableId: ""
    },
    {
        id: 'popular_games_12',
        image: 'https://luckmedia.link/sms_jetx/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format',
        name: 'JetX',
        gameId: 'SMS-jetx',
        tableId: 'SMS'
    },
];